<div id="company-selection-page" class="select-company container-fluid page-container">
    <div class="loading-container" *ngIf="aCompanyHasBeenSelected">
        <lsq-circle-loader></lsq-circle-loader>
        <h2 class="text-center" i18n>Logging in...</h2>
    </div>

    <ng-container *ngIf="!aCompanyHasBeenSelected">
        <h1 class="company-selection-page-title" i18n>
            Select Account
        </h1>

        <div class="company-selection-container row">
            <div
                class="col-12 order-2 order-lg-1"
                [ngClass]="{
                    'col-lg-8': !!networkRequests?.length,
                    'col-lg-12': !networkRequests?.length
                }"
            >
                <card class="company-selection-card" headerTitle="Your Accounts" i18n-headerTitle>
                    <div card-body class="company-selection-card-body">
                        <div class="company-selection-text">
                            <h4 i18n>Select Account to Manage</h4>
                            <p i18n>
                                When multiple accounts are associated with your email, you must
                                choose which account you’d like to manage. Once you have logged in,
                                you can switch between accounts at any time by selecting “Switch
                                Account” in the top-right dropdown menu.
                            </p>
                        </div>

                        <div class="company-selection-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="expand-button-cell"></th>
                                        <th i18n>Account</th>
                                        <th *ngIf="!(responsiveService.smBelow | async)" i18n>
                                            FastTrack Experience
                                        </th>
                                        <th style="text-align: right;" i18n>Log&nbsp;In</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let companyRow of companiesDataSource.rows$ | async;
                                            let i = index
                                        "
                                        [class.child-company]="!!companyRow.parentCompanyKey"
                                    >
                                        <td class="expand-button-cell">
                                            <div
                                                *ngIf="companyRow.hasChildren"
                                                [attr.tabindex]="0"
                                                (click)="
                                                    handleParentCompanyToggleClick(companyRow, i)
                                                "
                                                [style.cursor]="'pointer'"
                                            >
                                                <lsq-icon
                                                    [type]="
                                                        expandedParentCompanyKeys.has(
                                                            companyRow.companyKey
                                                        )
                                                            ? icons.ChevronDown
                                                            : icons.ChevronRight
                                                    "
                                                    [color]="color.Black"
                                                >
                                                </lsq-icon>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="company-name">{{ companyRow.name }}</div>
                                            <div
                                                *ngIf="companyRow.relationshipName"
                                                class="relationship-name"
                                            >
                                                {{ companyRow.relationshipName }}
                                            </div>
                                            <div
                                                *ngIf="responsiveService.smBelow | async"
                                                class="mobile-application-text"
                                                [ngClass]="
                                                    applicationColors[
                                                        companyRow.thirdPartyReferenceType
                                                    ]
                                                "
                                            >
                                                <b>{{
                                                    applicationNames[
                                                        companyRow.thirdPartyReferenceType
                                                    ]
                                                }}</b>
                                            </div>
                                        </td>
                                        <td *ngIf="!(responsiveService.smBelow | async)">
                                            {{
                                                applicationNames[companyRow.thirdPartyReferenceType]
                                            }}
                                        </td>
                                        <td
                                            class="icon login-arrow"
                                            (click)="handleCompanyClick(companyRow.companyKey)"
                                            style="text-align: right;"
                                        >
                                            <lsq-icon
                                                [type]="icons.RightArrowSmall"
                                                [color]="
                                                    applicationColors[
                                                        companyRow.thirdPartyReferenceType
                                                    ]
                                                "
                                            ></lsq-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div
                        *ngIf="!!networkRequests?.length"
                        card-body
                        class="new-network-requests-card-body"
                        [style]="{ marginTop: '-2rem' }"
                    >
                        <div class="new-network-requests-text">
                            <h4 i18n>New Network Requests</h4>
                            <p i18n>
                                A new company would like to add you to their FastTrack network.
                                Complete enrollment for each company you would like to add and
                                manage in your FastTrack account.
                            </p>
                        </div>

                        <div class="new-network-requests-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th i18n>Network Request</th>
                                        <th *ngIf="!(responsiveService.smBelow | async)" i18n>
                                            Request Expires In
                                        </th>
                                        <th style="text-align: right;" i18n>Enroll</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let networkRequest of networkRequests">
                                        <td>
                                            <div class="company-name">
                                                {{ networkRequest.companyName }}
                                            </div>
                                            <div
                                                *ngIf="networkRequest.buyerCompanyName"
                                                class="relationship-name"
                                            >
                                                {{ networkRequest.buyerCompanyName }}
                                            </div>
                                        </td>
                                        <td>{{ networkRequest.expiresInDays }} days</td>
                                        <td
                                            class="network-request-begin-enrollment-button icon"
                                            (click)="startEnrollmentWorkflow(networkRequest)"
                                            style="text-align: right;"
                                        >
                                            <lsq-icon
                                                [type]="icons.FaPlusCircle"
                                                [color]="
                                                    applicationColors[
                                                        thirdPartyReferenceType.FinancingSeller
                                                    ]
                                                "
                                            ></lsq-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </card>
            </div>
            <div class="col-12 order-1 col-lg-4 order-lg-2" *ngIf="!!networkRequests?.length">
                <data-card
                    [showSubSection]="true"
                    [lightBorder]="true"
                    class="network-management-data-card"
                >
                    <h3 class="network-management-title" i18n>Network Management</h3>

                    <div class="network-detail">
                        <div class="network-detail-header" i18n>What is a Network Request?</div>
                        <p i18n>
                            LSQ FastTrack allows Buyers and Sellers to manage multiple accounts
                            across the LSQ Network.
                        </p>
                    </div>

                    <div class="network-detail">
                        <div class="network-detail-header" i18n>Need More Help?</div>
                        <p i18n>Contact FastTrack Support for additional support.</p>
                    </div>

                    <div data-card-sub-section>
                        <div class="network-detail-header">FastTrack Support</div>
                        <div class="network-detail-email">
                            <span i18n>Email:&nbsp;</span
                            ><a href="mailto:fasttrack-support@lsq.com"
                                >fasttrack-support@lsq.com</a
                            >
                        </div>
                        <div class="network-detail-phone">
                            <span i18n>Phone:&nbsp;</span><span>877-267-2293</span>
                        </div>
                    </div>
                </data-card>
            </div>
        </div>
    </ng-container>
</div>
<ng-template #enrollmentSupplierAgreementModalBody>
    <p
        class="body"
        [style]="{
            marginBottom: '2rem'
        }"
    >
        Please read and agree to the terms:
    </p>
    <card [headerTitle]="'Supplier Agreement'">
        <div
            card-body
            [style.padding]="'3rem'"
            [style.height]="'30rem'"
            (scroll)="scrollAgreement($event)"
            class="vendor-agreement overflow-auto"
        >
            <scf-vendor-agreement-text></scf-vendor-agreement-text>
        </div>
    </card>
    <div [formGroup]="acceptedTermsForm" [style.margin-top]="'3rem'">
        <lsq-checkbox
            [group]="acceptedTermsForm"
            formControlName="acceptedTerms"
            id="accept-vendor-agreement"
            label="I've read and accept the terms in the Supplier Agreement."
        >
        </lsq-checkbox>
    </div>
</ng-template>
<ng-template #enrollmentPaymentMethodModalBody>
    <p
        class="body"
        [style]="{
            marginBottom: '20px'
        }"
    >
        Where should we send your payments? Please enter the information for the payment method
        you’d like to use for early payment requests.
    </p>
    <add-bank-account-form></add-bank-account-form>
</ng-template>
<ng-template #newAccountAddedConfirmationModalBody>
    <div class="modal-body">
        <p i18n>
            {{ enrollmentBuyerName }} has been added to your account. If you need to make changes to
            this relationship, please contact FastTrack Support for assistance.
        </p>
        <br />
        <data-card class="contact-info-card">
            <div class="contact-info">
                <div>
                    <span>Email: </span
                    ><a href="mailto:fasttrack-support@lsq.com" class="mail-to preserve-case"
                        >fasttrack-support@lsq.com</a
                    >
                </div>
                <div><span i18n>Phone: </span>877-267-2293</div>
            </div>
        </data-card>
    </div>
</ng-template>
